<template>
  <div class="table-list">
    <div class="table-search">
      <div class="table-list-title">{{ $t('friends.orderdetails') }}</div>
      <el-form ref="dataFormRef" :inline="true" :model="dataForm" label-position="top">
        <el-form-item prop="isPay">
          <el-select
              v-model="dataForm.orderstatus"
              style="width:300px;"
              @change="getTableList(1)"
              :placeholder="$t('order.whetherpayment')">
            <el-option v-for="(item,index) in statusList"
                       :key="index"
                       :label=item.label
                       :value=item.value>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <template v-if="tableList&&tableList.length>0">
      <el-table
          :data="tableList"
          class="w-100">
        <el-table-column
            prop="id"
            label="ID">
        </el-table-column>
        <el-table-column
            width="150"
            prop="orderid"
            label="Order ID">
        </el-table-column>
        <el-table-column
            width="100"
            prop="ticketid"
            label="Ticket ID">
        </el-table-column>
        <el-table-column
            width="100"
            label="Buy Type">
          <template v-slot="scope">
            {{ filterObj(buyTypeList,'value',scope.row.buytype).label }}
          </template>
        </el-table-column>
        <el-table-column
            width="80"
            prop="userid"
            label="User ID">
        </el-table-column>
        <el-table-column
            width="170"
            prop="loginemail"
            label="Login Email">
        </el-table-column>
        <el-table-column
            width="100"
            prop="goodsid"
            label="Goods ID">
        </el-table-column>
        <el-table-column
            width="100"
            prop="skuid"
            label="Sku ID">
        </el-table-column>
        <el-table-column
            width="120"
            prop="paytotal"
            label="Pay Total">
        </el-table-column>
        <el-table-column
            width="120"
            prop="beforeprice"
            label="Before Price">
        </el-table-column>
        <el-table-column
            width="120"
            prop="discountprice"
            label="Discount Price">
        </el-table-column>
        <el-table-column
            width="100"
            prop="num"
            label="Num">
        </el-table-column>
        <el-table-column
            width="100"
            prop="num"
            label="Num">
        </el-table-column>
        <el-table-column
            width="150"
            label="Order Status">
          <template v-slot="scope">
            {{ filterObj(statusList,'value',scope.row.orderstatus).label }}
          </template>
        </el-table-column>
        <el-table-column
            width="100"
            prop="remark"
            label="Remark">
        </el-table-column>
        <el-table-column
            width="100"
            prop="refundid"
            label="Refund ID">
        </el-table-column>
        <el-table-column
            width="130"
            prop="refundamount"
            label="Refund Amount">
        </el-table-column>
        <el-table-column
            width="120"
            prop="refundremark"
            label="refund Remark">
        </el-table-column>
        <el-table-column
            width="120"
            prop="createTime"
            label="Create Time">
        </el-table-column>
        <el-table-column
            width="120"
            prop="updateTime"
            label="Update Time">
        </el-table-column>
      </el-table>
      <div class="large tr mt-2">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
      <div class="small tr mt-2">
        <el-pagination
            @currenct-change="handleCurrentChange"
            :current-page="page"
            small
            layout="prev, pager, next"
            :total="total">
        </el-pagination>
      </div>
    </template>
    <div v-else class="empty">
      <img :src="`${$g.imgPrefix}/img/common/no-result.webp`">
      <div class="empty-text">暂无数据</div>
    </div>
  </div>
</template>

<script>
import {
  getUserInfo,
  filterObj,
  MessageError,
  isEmpty
} from "@/util/util";
import {
  getUserOrderList
} from "@/request/requests"
export default {
  name: "order",
  data() {
    let typeOptions = [
      {
        value: "1",
        // label: "판촉 링크"
        // label: "Promotion link"
        label: this.$t('friends.promotionlink'),
      },
      {
        value: "2",
        // label: "할인 코드"
        // label: "Discount code"
        label: this.$t('friends.discountcode'),
      }
    ];
    let comstatusOptions = [
      {
        value: "1",
        // label: "正常"
        // label: "표준"
        label: this.$t('friends.normal'),
      },
      {
        value: "0",
        // label: "无效"
        // label: "무효"
        label: this.$t('friends.invalid'),
      },
    ]
    return {
      dataForm:{
        orderstatus:''
      },
      userinfo:"",
      typeOptions,
      comstatusOptions,
      tableList:[],
      page: 1,
      size: 10,
      total: 0,
      screenWidth: null,
      //订单状态 1：待支付  2：已支付  3：已退款
      statusList:[
        {
          value:'1',
          label:'Pending Payment'
        },
        {
          value:'2',
          label:'Payment'
        },
        {
          value:'3',
          label:'Refund'
        }
      ],
      buyTypeList:[
          //订阅
        {
          value:'1',
          label:'Subscribe'
        },
        {
          //兑换码
          value: '2',
          label: 'Redemption Code'
        },
        {
          //续费
          value:'3',
          label:'Renew'
        }
      ]
    }
  },
  methods: {
    filterObj,
    async getTableList(page) {
      let params = {
        size: this.size,
        page: !isEmpty(page) ? page : this.page,
        userid: this.userinfo.id,
        ...this.dataForm
      }
      let res = await getUserOrderList(this.$qs.stringify(params))
      if (res.status === "200") {
        this.tableList = res.data?.list;
        this.total = res.data?.total;
      } else {
        MessageError(res.msg);
      }
    },
    handleSizeChange(val) {
      this.size = val;
      this.page = 1;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.size = val;
      this.getTableList();
    },
    calcWidth() {
      this.screenWidth = window.screen.width;
      this.$forceUpdate();
    }

  },
  mounted(){
    let userInfo = getUserInfo()
    if (userInfo) {
      this.userinfo = JSON.parse(userInfo);
      this.getTableList();
    }
    this.$nextTick(() => {
      this.calcWidth();
      window.addEventListener("resize", this.calcWidth);
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcWidth);
  },
}
</script>

<style lang="scss" scoped>
.table-list{
  &-title{
    font-size:20px;
    @media (max-width:576.98px) {
      margin-bottom:20px;
    }
  }
  .empty{
    text-align: center;
    img{
      width:240px;
    }
  }
  .table-search{
    display:flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom:70px;
    ::v-deep .el-form-item{
      margin-bottom:0!important;
    }

    @media (max-width:576.98px) {
      display:revert;
    }

  }

}

</style>